/**
 * Default currency options for currency and price fields
 */
export const DEFAULT_CURRENCIES = [
  { code: 'USD', symbol: '$', label: 'USD - US Dollar ($)' },
  { code: 'EUR', symbol: '€', label: 'EUR - Euro (€)' },
  { code: 'GBP', symbol: '£', label: 'GBP - British Pound (£)' },
  { code: 'JPY', symbol: '¥', label: 'JPY - Japanese Yen (¥)' },
  { code: 'CAD', symbol: '$', label: 'CAD - Canadian Dollar ($)' },
  { code: 'AUD', symbol: '$', label: 'AUD - Australian Dollar ($)' },
  { code: 'CHF', symbol: 'Fr', label: 'CHF - Swiss Franc (Fr)' },
  { code: 'CNY', symbol: '¥', label: 'CNY - Chinese Yuan (¥)' },
  { code: 'INR', symbol: '₹', label: 'INR - Indian Rupee (₹)' },
  { code: 'SAR', symbol: '﷼', label: 'SAR - Saudi Riyal (﷼)' },
  { code: 'AED', symbol: 'د.إ', label: 'AED - UAE Dirham (د.إ)' },
  { code: 'EGP', symbol: '£', label: 'EGP - Egyptian Pound (£)' },
];

export const DEFAULT_CURRENCY = 'USD';
